module.exports = __webpack_public_path__ + "static/img/solution-y-1.4827554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-y-1.png
// module id = dTbU
// module chunks = 10